import { createAsyncThunk } from '@reduxjs/toolkit'
import { API_BASE_URL, API_KEY_ID, API_KEY_SECRET, BASE_URL } from '../../constant'
import { clearUserData } from '../reducers/authReducer'
import axios from 'axios'

axios.defaults.withCredentials = true;

/**
 * REGISTER USER
 */
export const signUp = createAsyncThunk('user/signUp', async (data, { rejectWithValue }) => {
    try {
        // Await CSRF cookie setup
        await axios.get(`${BASE_URL}/sanctum/csrf-cookie`);
        const res = await axios.post(`${API_BASE_URL}/signup`, data, {
            headers: {
                'X-API-KEY-ID': API_KEY_ID,
                'X-API-KEY-SECRET': API_KEY_SECRET,
            },
        });
        return res.data;
    } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
    }
});

/**
 * LOGIN USER
 */
export const signIn = createAsyncThunk('user/signIn', async (data, { rejectWithValue }) => {
    try {
        // Await CSRF cookie setup
        await axios.get(`${BASE_URL}/sanctum/csrf-cookie`);
        const res = await axios.post(`${API_BASE_URL}/signin`, data, {
            headers: {
                'X-API-KEY-ID': API_KEY_ID,
                'X-API-KEY-SECRET': API_KEY_SECRET,
            },
        });
        return res.data;
    } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
    }
});

/**
 * LOGOUT USER
 */
export const signOut = createAsyncThunk('user/signOut', async (token, { dispatch, rejectWithValue }) => {
    try {
        // Await CSRF cookie setup
        await axios.get(`${BASE_URL}/sanctum/csrf-cookie`);
        const res = await axios.post(`${API_BASE_URL}/signout`, {}, {
            headers: {
                'X-API-KEY-SECRET': API_KEY_SECRET,
                'X-API-KEY-ID': API_KEY_ID,
                'Authorization': `Bearer ${token}`,
            },
        });

        console.log("Action signout:", res.data)
        return res.data;
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(clearUserData());
            return rejectWithValue('Session expired. Please log in again.');
        }
        return rejectWithValue(error.response?.data || 'Failed to sign out');
    }
});

/**
 * FORGOT PASSWORD
 */
export const forgotPassword = createAsyncThunk('user/forgotPassword', async (data, { rejectWithValue }) => {
    try {
        // Await CSRF cookie setup
        await axios.get(`${BASE_URL}/sanctum/csrf-cookie`);
        const res = await axios.post(`${API_BASE_URL}/forgot-password`, data, {
            headers: {
                'X-API-KEY-ID': API_KEY_ID,
                'X-API-KEY-SECRET': API_KEY_SECRET,
            },
        });
        return res.data;
    } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
    }
});

/**
 * RESET PASSWORD
 */
export const resetPassword = createAsyncThunk('user/resetPassword', async (data, { rejectWithValue }) => {
    try {
        // Await CSRF cookie setup
        await axios.get(`${BASE_URL}/sanctum/csrf-cookie`);
        const res = await axios.post(`${API_BASE_URL}/reset-password`, data, {
            headers: {
                'X-API-KEY-ID': API_KEY_ID,
                'X-API-KEY-SECRET': API_KEY_SECRET,
            },
        });
        return res.data;
    } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
    }
});

/**
 * FETCH USER DATA
 */
export const fetchUser = createAsyncThunk('user/fetchUser', async (_, { rejectWithValue }) => {
    try {
        // Setup CSRF cookie for Sanctum
        await axios.get(`${BASE_URL}/sanctum/csrf-cookie`);

        // Get CSRF token from cookies
        const csrfToken = document.cookie
            .split('; ')
            .find(row => row.startsWith('XSRF-TOKEN='))
            ?.split('=')[1];

        const token = localStorage.getItem('token');
        const res = await axios.get(`${BASE_URL}/api/user`, {
            headers: {
                'X-API-KEY-ID': API_KEY_ID,
                'X-API-KEY-SECRET': API_KEY_SECRET,
                'Authorization': token ? `Bearer ${token}` : undefined,
                'X-XSRF-TOKEN': csrfToken ? decodeURIComponent(csrfToken) : undefined,
            },
        });
        return res.data;
    } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
    }
});

/**
 * UPDATE PROFILE
 */
export const updateProfile = createAsyncThunk('user/updateProfile', async ({ name, mobile }, { rejectWithValue }) => {
    try {
        // Setup CSRF cookie for Sanctum
        await axios.get(`${BASE_URL}/sanctum/csrf-cookie`);

        // Get CSRF token from cookies
        const csrfToken = document.cookie
            .split('; ')
            .find(row => row.startsWith('XSRF-TOKEN='))
            ?.split('=')[1];

        const token = localStorage.getItem('token');
        const res = await axios.post(`${API_BASE_URL}/update-profile`, { name, mobile }, {
            headers: {
                'X-API-KEY-ID': API_KEY_ID,
                'X-API-KEY-SECRET': API_KEY_SECRET,
                'Authorization': token ? `Bearer ${token}` : undefined
            },
        });
        return res.data;
    } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
    }
});

/**
 * FETCH USER ORDERS
 */
export const fetchUserOrders = createAsyncThunk('user/fetchUserOrders', async (page = 1, { rejectWithValue }) => {
    try {
        const token = localStorage.getItem('token');
        const res = await axios.get(`https://images.dentalstores.in/api/orders_app`, {
            params: { page },
            headers: {
                'X-API-KEY-ID': API_KEY_ID,
                'X-API-KEY-SECRET': API_KEY_SECRET,
                'Authorization': token ? `Bearer ${token}` : undefined,
            },
        });
        return res.data;
    } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
    }
});